import { InvoiceStatuses } from "@legacy/core/utils/enums"

import { ObjectsView } from "@organisms"

import { INVOICES_ROUTES } from "@routes/invoices"

export const InvoiceObjectsViewTabs = () => (
    <ObjectsView.Tabs>
        <ObjectsView.Tab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", InvoiceStatuses.pending],
                ["status", InvoiceStatuses.sent],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="pending"
            phase="open"
            title="Pending"
            endpointKwargs={[
                ["status", InvoiceStatuses.pending],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="outstanding"
            phase="open"
            title="Outstanding"
            endpointKwargs={[
                ["status", InvoiceStatuses.sent],
                ["is_overdue", "false"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="overdue"
            phase="open"
            title="Overdue"
            endpointKwargs={[
                ["status", InvoiceStatuses.sent],
                ["is_overdue", "true"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="all_closed"
            phase="closed"
            title="All Closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", InvoiceStatuses.paid],
                ["status", InvoiceStatuses.voided],
                ["status", InvoiceStatuses.forgiven],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="paid"
            phase="closed"
            title="Paid"
            endpointKwargs={[
                ["status", InvoiceStatuses.paid],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="voided"
            phase="closed"
            title="Voided"
            endpointKwargs={[
                ["status", InvoiceStatuses.voided],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <ObjectsView.Tab
            id="forgiven"
            phase="closed"
            title="Forgiven"
            endpointKwargs={[
                ["status", InvoiceStatuses.forgiven],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
    </ObjectsView.Tabs>
)
